export default {
    "fr": {
        "Error {error}": "Erreur {error}",
        "Error title": "Oh Oh.",
        "Error message": "Nous rencontrons un problème. Ne vous inquietez pas, nous faisons remonter votre problème.",
        "403 title": "Halte là !",
        "403 message": "Cette page ne vous est pas accessible pour le moment",
        "404 title": "Ah mince !",
        "404 message": "Nous avons beau chercher, cette page est introuvable."
    }
}
